// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-favorite-form[data-v-3bbfb5ea]{width:100%;margin:0}`, "",{"version":3,"sources":["webpack://./src/components/map/ClickPopup.vue"],"names":[],"mappings":"AACA,oCACC,UAAA,CACA,QAAA","sourcesContent":["\n.new-favorite-form {\n\twidth: 100%;\n\tmargin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
